import api from "./axios";

/* 프로젝트 기본정보 */
export const getProject = async (projectId) => {
  const res = await api.get(`project/${projectId}`);
  return res.data;
};

/* 개요 저장 */
export const createOverview = async (projectId, payload) => {
  const hasMulti =
    Array.isArray(payload?.birdseye_images) &&
    payload.birdseye_images.some((f) => f instanceof File);
  const hasSingle = payload?.birdseye_image instanceof File;
  if (hasMulti || hasSingle) {
    const fd = new FormData();
    // 일반 값
    Object.entries(payload || {}).forEach(([k, v]) => {
      if (v === null || v === undefined) return;
      if (k === "birdseye_images") return; // 아래에서 따로 처리
      fd.append(k, v);
    });
    // 여러 장
    if (hasMulti) {
      payload.birdseye_images.forEach((f) => fd.append("birdseye_images", f));
    }
    const res = await api.post(`project/${projectId}/overview/`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } else {
    const res = await api.post(`project/${projectId}/overview/`, payload);
    return res.data;
  }
};

/* 개요 수정 */
export const updateOverview = async (projectId, overviewId, payload) => {
  const hasMulti =
    Array.isArray(payload?.birdseye_images) &&
    payload.birdseye_images.some((f) => f instanceof File);
  const hasSingle = payload?.birdseye_image instanceof File;

  if (hasMulti || hasSingle) {
    const fd = new FormData();
    Object.entries(payload || {}).forEach(([k, v]) => {
      if (v === null || v === undefined) return;
      if (k === "birdseye_images") return; // 아래에서 따로
      if (k === "delete_birdseye_image_ids") {
        fd.append(k, Array.isArray(v) ? JSON.stringify(v) : String(v));
        return;
      }
      if (k === "replace_birdseye_images") {
        if (v) fd.append("replace_birdseye_images", "true");
        return;
      }
      fd.append(k, v);
    });
    if (hasMulti) {
      payload.birdseye_images.forEach((f) => fd.append("birdseye_images", f));
    }
    const res = await api.put(
      `project/${projectId}/overview/${overviewId}/`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return res.data;
  } else {
    const res = await api.put(
      `project/${projectId}/overview/${overviewId}/`,
      payload
    );
    return res.data;
  }
};

/* 조직도 함수 세트 */
export const createOrganization = async (projectId, payload) => {
  const res = await api.post(`project/${projectId}/organization/`, payload);
  return res.data;
};

export const updateOrganization = async (projectId, orgId, payload) => {
  const res = await api.put(`project/${projectId}/organization/${orgId}/`, payload);
  return res.data;
};

export const deleteOrganization = async (projectId, orgId) => {
  const res = await api.delete(`project/${projectId}/organization/${orgId}/`);
  return res.data;
};

export const getOrganization = async (projectId) => {
  const res = await api.get(`project/${projectId}/organization/`);
  return res.data;
};

